import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Button from 'react-bootstrap/lib/Button';

import t from '../../lib/I18n';
import AmazonLoginActions from '../../actions/AmazonLoginActions';

import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import ConfirmModal from '../general/ConfirmModal';
import ModalTabs from '../general/ModalTabs';
import Icon from '../general/Icon';

class RegisterModalHeader extends React.PureComponent {
    state = {
        isConfirmVisible: false,
        logoutAmazon: false
    }

    filteredSteps = [];

    componentDidMount() {
        this.filteredSteps = this.getFilteredSteps();
    }

    getFilteredSteps = () => {
        const { steps, hideSteps } = this.props;
        return Object.entries(steps)
            .filter(([stepName]) => !hideSteps.includes(stepName));
    };

    handleContinueLoginTab = () => {
        const { handleLogin, onClose } = this.props;
        const { logoutAmazon } = this.state;

        if (logoutAmazon) {
            AmazonLoginActions.logout();
        }

        onClose();
        handleLogin();
    }

    getPreviousStepDetails = () => {
        const {step} = this.props;
        const filteredSteps = this.filteredSteps;
        const currentStepIndex = filteredSteps.findIndex(i => i[1] === step);
        return filteredSteps[currentStepIndex - 1];
    }

    getPreviousStepName = () => {
        return this.getPreviousStepDetails()[0];
    }

    getPreviousStepNumber = () => {
        return this.getPreviousStepDetails()[1];
    }

    handleStep = () => {
        const {handleStepBack} = this.props;
        const prevStepNumber = this.getPreviousStepNumber();

        handleStepBack(prevStepNumber);
    }

    isFirstStep = () => {
       return !this.getPreviousStepDetails();
    }

    toggleModal = () =>
        this.setState(state => ({ isConfirmVisible: !state.isConfirmVisible }));

    logoutAmazon = e => {
        e.preventDefault();

        this.setState({ logoutAmazon: true });
        this.toggleModal();
    }

    render() {
        const {
            amazonEmail,
            hideClose,
            onClose,
            isAmazonRegistration,
            dictionaryPrefix
        } = this.props;
        const {
            isConfirmVisible
        } = this.state;

        return (
            <React.Fragment>
                <ConfirmModal
                    className="modal--sm modal--small-confirm"
                    closeText="No, go back"
                    continueText="Yes, close the form"
                    onClose={ this.toggleModal }
                    onContinue={ onClose }
                    header={ false }
                    show={ isConfirmVisible }
                    text= { t('account.register.closeConfirm') }
                />
                {this.isFirstStep() ? (
                    <ModalTabs activeTab="register">
                    <ModalTabs.Tab name="register" title={ t('account.register') } />
                    <ModalTabs.Tab name="login" onClick={ this.handleContinueLoginTab } title={ t('account.login') } />
                </ModalTabs>
                ) : (
                    <div className="modal__header--go-back" onClick={this.handleStep}>
                        <Icon icon="chevronslim" />
                        {t(`${dictionaryPrefix}${this.getPreviousStepName().toLowerCase()}`)}
                    </div>
                )}

                {!hideClose && (
                    <Button className="btn btn-link modal-header__close-button" onClick={this.toggleModal}>
                        <Icon icon="close" srOnly={t('button.text.close')} />
                    </Button>
                )}

                <div className="modal__header__wrapper modal__header__wrapper--hide-mobile">
                    <div className="modal__header__right modal__header__right--login">
                        { isAmazonRegistration && <span className="modal__header__amazon-logout">
                            <FormattedHTMLMessage message="account.register.amazon.logout.info" email={ amazonEmail } />
                            {' '}<a href="#" onClick={ this.logoutAmazon }>{ t('account.register.amazon.logout.action')}</a></span>
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

RegisterModalHeader.propTypes = {
    handleLogin: PropTypes.func,
    isAmazonRegistration: PropTypes.bool,
    isFormDirty: PropTypes.bool,
    hideClose: PropTypes.bool,
    onClose: PropTypes.func,
    showExtraOptions: PropTypes.bool,
    amazonEmail: PropTypes.string,
    step: PropTypes.object,
    steps: PropTypes.object,
    hideSteps: PropTypes.object,
    handleStepBack: PropTypes.func,
    dictionaryPrefix: PropTypes.string
};

RegisterModalHeader.defaultProps = {
    handleLogin: _.noop,
    isAmazonRegistration: false,
    isFormDirty: false,
    hideClose: false,
    onClose: _.noop,
    showExtraOptions: false,
    amazonEmail: '',
    step: {},
    steps: {},
    hideSteps: [],
    handleStepBack: _.noop,
    dictionaryPrefix: ''
};

export default RegisterModalHeader;



// WEBPACK FOOTER //
// ./src/components/login/RegisterModalHeader.js